import { v4 as uuidv4 } from 'uuid'

export class ReveniuSubscriptionId {
  readonly value: string;
  constructor(value: string) {
    this.value = value;
  }

  toString(): string {
    return this.value;
  }

  static random(): ReveniuSubscriptionId {
    return new ReveniuSubscriptionId(uuidv4());
  }
}
